// extracted by mini-css-extract-plugin
module.exports = {"mondai":"MondaiSelect_mondai__Zx291"};